import React from 'react';
import { Navbar, Nav, Container, Offcanvas } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons';
import "../css/styles.css";
import plugintechLogo from '../assets/plugintech.png';

const Header = () => {
    return (
        <>
            <Navbar expand="lg" bg="dark" variant="dark" className="py-3 border-bottom" fixed="top">
                <Container className="d-flex flex-column align-items-center">
                    {/* Logo centralizada */}
                    <Navbar.Brand href="/" className="text-center">
                        <img 
                            src={plugintechLogo} 
                            alt="PluginTech" 
                            style={{ 
                                height: '100px', 
                                maxWidth: '550px',
                                objectFit: 'contain'
                            }} 
                        />
                    </Navbar.Brand>

                    {/* Menu Desktop 
                            <Nav.Link href="#servicos" className="text-white px-4 menu-item">Serviços</Nav.Link>
                            <Nav.Link href="#aplicativos" className="text-white px-4 menu-item">Aplicativos</Nav.Link>
                            <Nav.Link href="#blog" className="text-white px-4 menu-item">Blog</Nav.Link>
                    */}
                    <div className="d-none d-lg-block w-100">
                        <hr className="bg-white opacity-50" />
                        <Nav className="justify-content-center">
                            <Nav.Link href="#inicio" className="text-white px-4 menu-item">Início</Nav.Link>
                            <Nav.Link href="#servicos" className="text-white px-4 menu-item">Produtos & Serviços</Nav.Link>
                            <Nav.Link href="#contato" className="text-white px-4 menu-item">Contato</Nav.Link>
                            <Nav.Link 
                                href="https://pdfacil.com.br/" 
                                target="_blank" 
                                rel="noopener noreferrer" 
                                className="text-white px-4 menu-item"
                            >
                                Sistema PDFácil <FontAwesomeIcon icon={faExternalLinkAlt} className="ms-1" size="sm" />
                            </Nav.Link>
                        </Nav>
                    </div>

                    {/* Menu Mobile 
                        <Nav.Link href="#produtos" className="text-white mb-2 menu-item">Produtos</Nav.Link>
                        <Nav.Link href="#aplicativos" className="text-white mb-2 menu-item">Aplicativos</Nav.Link>
                        <Nav.Link href="#blog" className="text-white mb-2 menu-item">Blog</Nav.Link>
                    
                    */}
                    <div className="d-lg-none w-100 text-end">
                        <Navbar.Toggle aria-controls="offcanvasNavbar" className="border-0" />
                    </div>
                </Container>

                {/* Offcanvas fora do Container para não ser afetado pelo layout interno */}
                <Navbar.Offcanvas
                    id="offcanvasNavbar"
                    aria-labelledby="offcanvasNavbarLabel"
                    placement="start"
                    className="bg-dark text-white d-lg-none"
                >
                    <Offcanvas.Header closeButton closeVariant="white">
                        <Offcanvas.Title id="offcanvasNavbarLabel">Menu</Offcanvas.Title>
                    </Offcanvas.Header>
                    <Offcanvas.Body>
                        <Nav className="flex-column">
                            <Nav.Link href="#inicio" className="text-white mb-2 menu-item">Início</Nav.Link>
                            <Nav.Link href="#servicos" className="text-white mb-2 menu-item">Produtos & Serviços</Nav.Link>
                            <Nav.Link href="#contato" className="text-white mb-2 menu-item">Contato</Nav.Link>
                            <Nav.Link 
                                href="https://pdfacil.com.br/" 
                                target="_blank" 
                                rel="noopener noreferrer" 
                                className="text-white mb-2 menu-item"
                            >
                                Sistema PDFácil <FontAwesomeIcon icon={faExternalLinkAlt} className="ms-1" size="sm" />
                            </Nav.Link>
                        </Nav>
                    </Offcanvas.Body>
                </Navbar.Offcanvas>
            </Navbar>

            {/* Espaço para compensar o header fixo */}
            <div style={{ height: '110px' }}></div>
        </>
    );
};

export default Header;
